import type { IUpcomingMenu } from 'models/UpcomingMenu';
import { ArrivingStatus } from 'models/UpcomingMenu';

/**
 * Returns true if the next scheduled menu is customized.
 */
const isAnyMenuCustomized = (upcomingMenus: IUpcomingMenu[]) => (
  upcomingMenus.some((item) => (
    item.arriving_status === ArrivingStatus.SCHEDULED && item.overridden_recipes
  ))
);

function useIsAnyMenuCustomized(): typeof isAnyMenuCustomized {
  return isAnyMenuCustomized;
}

export default useIsAnyMenuCustomized;
